<template>
  <PageTerms v-bind="{ terms }" />
</template>

<script setup>
const terms = {
  name: "Creator Rewards Policy",
  lastUpdated: "1st June 2025",
  content: [
    {
      heading: "Introduction",
      clauses: [
        "NamiComi intends to implement an Ad Revenue Sharing program in the future, as one of the many monetization opportunities available on the NamiComi ecosystem.",
        "Details of the Ad Revenue Sharing program will be disclosed in due course.",
        "In advance of the introduction of the Ad Revenue Sharing program, we are introducing the Creator Rewards program.",
        "The Creator Rewards program will begin on 1st January 2024 at midnight UTC.",
        "The Creator Rewards program will be phased out when the Ad Revenue Sharing program is implemented in the future.",
      ],
    },
    {
      heading: "Eligibility",
      clauses: [
        "The Creator Rewards program is open to legal residents of Argentina, Australia, Austria, Andorra, Bangladesh, Belgium, Brazil, Bulgaria, Canada, Chile, China, Colombia, Costa Rica, Croatia, Cyprus, Czech Republic, Denmark, Egypt, Estonia, Finland, France, Georgia, Germany, Ghana, Gibraltar, Greece, Hong Kong, Hungary, Iceland, India, Indonesia, Ireland, Israel, Italy, Japan, Kenya, Latvia, Liechtenstein, Lithuania, Luxembourg, Malaysia, Malta, Mexico, Monaco, Morocco, Nepal, Netherlands, New Zealand, Norway, Pakistan, Philippines, Poland, Portugal, Romania, San Marino, Singapore, Slovakia, Slovenia, South Africa, South Korea, Sri Lanka, Spain, Sweden, Switzerland, Tanzania, Thailand, Turkey, Uganda, Ukraine, United Arab Emirates, United Kingdom, United States of America, Uruguay, Vietnam, and Zambia, who are over the age of 14 when entering the program.",
        "Entrants under the age of 18 may need to gain permission from their parent or legal guardian in order to claim their reward.",
        "In order to participate in the program, Creators must make an Organization, set up their Payment Account, make at least one Subscription Tier, and publish a Title with at least one Chapter.",
        "The Subscription Tier(s) must be continuously available from the 1st of each month. If Subscription Tiers are created in the middle of the month, entry into the program will occur at the start of the following month.",
        "Creators must monetize via subscriptions exclusively on NamiComi.",
        "A Title is eligible to enter the program once it has reached the minimum thresholds defined in Section 3.",
        "In addition, there must be at least 1 Chapter published in that month for the Title to enter for that month.",
        "The <a href='/en/terms/content' class='underline text-nami-nami-blue'>Content Guidelines</a> also apply to Titles entering the program. ",
        "If a Creator has multiple eligible Titles, the Title with the highest Page Views will qualify for that month.",
      ],
    },
    {
      heading: "Minimum Thresholds",
      clauses: [
        "The minimum thresholds for a Title to enter the program is 1,000 Followers and 40,000 monthly Page Views.",
        "Monthly Page Views for the Title page and all Chapters in all languages are counted.",
        "Page Views that have a referral from MangaDex do not count.",
        "For Founding Creators, defined as Creators who make an Organization and publish at least one Title with at least one Chapter while NamiComi is in Open Beta, the minimum threshold is 100 Followers and 4,000 monthly Page Views.",
        "Founding Creators keep this benefit even after NamiComi leaves Open Beta.",
      ],
    },
    {
      heading: "Ineligibility",
      clauses: [
        "Titles which do not meet the minimum thresholds are not eligible to enter the program. ",
        "Titles which violate the content guidelines are not eligible to enter the program. ",
        "Employees and contractors of NamiComi and their families are not eligible to enter the program. ",
      ],
    },
    {
      heading: "Rewards",
      clauses: [
        {
          subheading: "The reward payments are tiered as follows:",
          subclauses: [
            "40,000 monthly Page Views: $80 USD",
            "100,000 monthly Page Views: $200 USD",
            "600,000 monthly Page Views: $800 USD",
            "1,500,000 monthly Page Views: $1,000 USD",
          ],
        },
        {
          subheading: "For Founding Creators, the following tiers also apply:",
          subclauses: [
            "4,000 monthly Page Views: $8 USD",
            "10,000 monthly Page Views: $20 USD",
            "20,000 monthly Page Views: $40 USD",
            "30,000 monthly Page Views: $60 USD",
          ],
        },
        "Titles qualifying for the program each month are announced by the 7th of the following month.",
        "The reward payment is credited to the Title's Organization payout balance by the end of the following month.",
      ],
    },
    {
      heading: "Limitations",
      clauses: [
        "The Creator Rewards program will be replaced by the Ad Revenue Sharing program in the future. ",
        "We reserve the right to amend the terms of the Creator Rewards program at any time.",
        "We reserve the right to withhold any reward payments upon detection of any violations of the Content Policy or any other Terms or Policy.",
        "Abusing Page Views in any way will result in restrictions including (but not limited to) disqualification from the Creator Rewards program.",
      ],
    },
  ],
};

const config = useRuntimeConfig();
const title = ref("Creator Rewards Policy");
const canonical = ref(`${config.public.baseUrl}/en/terms/creatorrewards`);
definePageMeta({ title: "Creator Rewards Policy" });

useHead({
  title: title,
  link: [{ rel: "canonical", href: canonical }],
  meta: [
    {
      property: "og:title",
      content: `${title.value} - ${config.public.siteName}`,
    },
  ],
});
</script>
